import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const ownedParkingKeys = {
    all: ['ownedParkings'],
    get: (filter, scope) => ['ownedParkings', filter, scope],
};
export const ownedParkingOptions = {
    get: (filter, scope, options) => queryOptions({
        queryKey: ownedParkingKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.get(filter, scope);
        },
        refetchInterval: options?.refetchInterval ? (query) => options.refetchInterval(query.state.data) : undefined,
    }),
    create: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.create(requests);
        },
    }),
    update: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.update(requests);
        },
    }),
    submitForVerification: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.submitForVerification(request);
        },
    }),
    deleteDraft: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.deleteDraft(request);
        },
    }),
    pause: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.pause(request);
        },
    }),
    setLotMode: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.setLotMode(request);
        },
    }),
    assignBilling: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.assignBilling(request);
        },
    }),
    saveEntrance: () => ({
        mutationFn: async (request) => {
            const repo = await resolveRepository(Domain.OwnedParking);
            return repo.saveEntrance(request);
        },
    }),
};
